<div class="container-visualizacao">
    <div class="row container-options">
        <div class="col-12">
            <button type="button" class="btn btn-primary" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Novo</button>                 
        </div>
    </div>
    <div class="row container-table">
        <div class="col-12">
            <table class="table table-striped table-hover table-bordered datatables" id="tableClassificacoesFaturamento">
                <thead>
                        <tr>
                            <th class="col-options" rowspan="2"></th>
                            <th class="col-codigo-integracao-erp" rowspan="2">Código ERP</th>
                            <th class="col-nome" rowspan="2">Nome</th>
                            <th class="text-center" colspan="2">Faturamento Mensal</th>
                            <th class="text-center" colspan="2">Faturamento Anual</th>
                        </tr>
                        <tr>
                            <!-- Faturamento Mensal -->
                            <th class="col-valor-faturamento-inicial text-right" title="Faturamento mensal inicial">Inicial</th>
                            <th class="col-valor-faturamento-final text-right" title="Faturamento mensal final">Final</th>
                            <!-- Faturamento Anual -->
                            <th class="col-valor-faturamento-inicial text-right" title="Faturamento anual inicial">Inicial</th>
                            <th class="col-valor-faturamento-final text-right" title="Faturamento anual final">Final</th>                            
                        </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities">
                        <td class="col-options">
                            <a (click)="edit(entity)"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>
                            <a (click)="delete(entity)"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
                        </td>
                        <td class="col-codigo-integracao-erp">{{entity.codigoIntegracaoErp}}</td>
                        <td class="col-nome">{{entity.nome}}</td>
                        <!-- Faturamento Mensal -->
                        <td class="col-valor-faturamento-inicial text-right">
                            {{entity.valorFaturamentoMensalInicial | decimalFormat: 1:2:2}}
                        </td>
                        <td class="col-valor-faturamento-final text-right">
                            {{entity.valorFaturamentoMensalFinal | decimalFormat: 1:2:2}}
                        </td>
                        <!-- Faturamento Anual -->
                        <td class="col-valor-faturamento-inicial text-right">
                            {{entity.valorFaturamentoAnualInicial | decimalFormat: 1:2:2}}
                        </td>
                        <td class="col-valor-faturamento-final text-right">
                            {{entity.valorFaturamentoAnualFinal | decimalFormat: 1:2:2}}
                        </td>
                    </tr>
                </tbody>
            </table>                     
        </div>
    </div>    
</div>